import { SVGFC } from '@repo/toolkit/types'

const A4FormatDocIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.8825 4.00244H13.8399V6.6623C13.8399 7.45748 14.4873 8.10486 15.2825 8.10486H18.0005V19.5758C18.0005 19.8187 17.8008 20.0184 17.5579 20.0184H6.8825C6.63961 20.0184 6.43994 19.8187 6.43994 19.5758V4.445C6.43994 4.20211 6.63961 4.00244 6.8825 4.00244Z"
        stroke={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5047 7.3059H15.5192C15.0375 7.3059 14.6431 6.91144 14.6431 6.42978V3.50244L18.5005 7.3059H18.5047Z"
        fill={color}
      />
      <path
        d="M9.20361 13.883L10.5572 10.1377H10.9932L12.3178 13.883H11.7988L11.4707 12.9239H10.059L9.72264 13.883H9.20361ZM10.2043 12.4962H11.3254L10.7815 10.8893H10.7649L10.2085 12.4962H10.2043ZM12.6168 13.0235V12.7329L14.1905 10.1377H14.7261V12.6207H15.2368V13.0235H14.7261V13.883H14.2195V13.0235H12.6168ZM13.1524 12.6207H14.2195V10.8643L14.2029 10.8602L14.1531 10.9889L13.1524 12.6207Z"
        fill={color}
      />
    </svg>
  )
}

export default A4FormatDocIcon
